import { create } from "zustand";
import { StatusValue } from "../../types/types";

interface CreatorStatusState {
  isLoading: boolean;
  error: string | null;
  updateCreatorStatus: (
    creatorId: string,
    status: StatusValue,
    promoCode: string,
    manualUniqueLink: string,
    selectedDomain: string,
    token: string,
    use_dub: boolean,
    extraVariables?: Record<string, string>
  ) => Promise<void>;
  reset: () => void;
}

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const useCreatorStatusStore = create<CreatorStatusState>((set) => ({
  isLoading: false,
  error: null,

  updateCreatorStatus: async (
    creatorId: string,
    status: StatusValue,
    promoCode: string,
    manualUniqueLink: string,
    selectedDomain: string,
    token: string,
    use_dub: boolean,
    extraVariables?: Record<string, string>
  ) => {
    set({ isLoading: true, error: null });
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/campaigns/updateCreatorStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            campaign_creator_id: creatorId,
            status,
            promo_code: promoCode,
            manual_unique_link: manualUniqueLink,
            selected_domain: selectedDomain,
            use_dub: use_dub,
            extra_variables: extraVariables ?? {},
          }),
        }
      );

      if (!response.ok) throw new Error("Failed to update creator status");

      set({ isLoading: false });
    } catch (error) {
      set({ error: (error as Error).message, isLoading: false });
    }
  },

  reset: () => set({ isLoading: false, error: null }),
}));
